import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Loading from '../common/lib/Loading';
import NoticeSiteHasBeenArchived from '../common/lib/NoticeSiteHasBeenArchived';
import PageNotFound from '../common/lib/PageNotFound';
import { MultiLang } from '../config';
import Functions from '../functions';
import './assets/pubmedpdf.css';
import PubmedPdfBreadcrumbs from './lib/PubmedPdfBreadcrumbs';
import PubmedPdfListItemPaper from './lib/PubmedPdfPaper';
import PubmedPdfUtils, { PubmedPdfBreadcrumbsData } from './lib/PubmedPdfUtils';

interface Props {
    lang: MultiLang;
    year: number;
    journalId: number;
}

interface State {
    loading: boolean;
    name: string;
}

class PubmedPdfPapersByYear extends Component<Props, State> {

    private isActive: boolean;

    constructor(props: Props) {
        super(props);
        this.isActive = false;
        this.state = {
            loading: true,
            name: '',
        };
    }

    componentDidMount() {
        this.isActive = true;
        this.updatePage();
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        const { lang, year, journalId } = this.props;
        if (prevProps.lang !== lang || prevProps.year !== year || prevProps.journalId !== journalId) {
            this.updatePage();
        }
    }

    componentWillUnmount() {
        this.isActive = false;
    }

    async updatePage() {
        await PubmedPdfUtils.initialize();
        if (this.isActive) {
            const name = PubmedPdfUtils.getName();
            this.setState({ loading: false, name });
        }
    }

    render() {
        const { lang, year, journalId } = this.props;
        const { loading, name } = this.state;
        if (loading) {
            return <Loading />;
        }
        if ('' === name) {
            return <PageNotFound lang={lang} />;
        }
        const mtitle = Functions.mlang(name, lang);
        const journal = PubmedPdfUtils.getJournal(journalId);
        if (journal === null) {
            return <PageNotFound lang={lang} />;
        }
        const breadcrumbs: PubmedPdfBreadcrumbsData[] = [
            { id: `y.${year}`, name: `${year}`, link: PubmedPdfUtils.getYearUrl(year, 0) },
            { id: `j.${journal.id}`, name: Functions.mlang(journal.name, lang), link: PubmedPdfUtils.getYearUrl(year, journalId) }
        ];
        const papers = PubmedPdfUtils.getPapersByJournalId(journalId, year);
        return (
            <div className="pubmedpdf">
                <Helmet>
                    <title>{mtitle} - {Functions.siteTitle(lang)}</title>
                </Helmet>
                <h3>{mtitle}</h3>
                <NoticeSiteHasBeenArchived lang={lang} />
                <PubmedPdfBreadcrumbs lang={lang} breadcrumbs={breadcrumbs} />
                <hr />
                <div className="papers">
                    {papers.map((paper) => {
                        return <PubmedPdfListItemPaper key={paper.id} lang={lang} paper={paper} />;
                    })}
                </div>
            </div>
        );
    }
}

export default PubmedPdfPapersByYear;
